import { 
  Box,
  Button, 
  Divider, 
  Flex, 
  Heading, 
  Switch, 
  Text, 
  Select, 
  useToast, 
  Input
} from '@chakra-ui/react'

import React, { Fragment,useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { BiArrowBack } from 'react-icons/bi';
import axios from 'axios'
import { Auth } from '../../component/Auth';

function NotificationDetails() {
  const [bodyData, setBodyData] = useState("")
  const [subjectData, setSubjectData] = useState("")
  const [variables, setVariables] = useState([])
  const [statusToggle, setStatusToggle] = useState(false)
  const [undoCounter , setUndoCounter] = useState(0)
  const [loadingToggle, setLoadingToggle] = useState(false)
  // const {isOpen, onOpen, onClose} = useDisclosure()
  const { id } = useParams()
  const toast = useToast()
  const navigate = useNavigate()
  // Variable Handler
  const variableHandler = (e) => {
    toast({
      title: `Variable copied successfully, press ctrl + v`,
      status: 'success',
      position: "top",
      isClosable: true,
    })
    navigator.clipboard.writeText(e.target.value)
  }
console.log(bodyData)
// Get Single Notification Details
  useEffect(() => {
    const fetchData = async () => {
      try{
      let response = await fetch(`${process.env.REACT_APP_NOTIFICATION_BASE_URL}/get-notification/${id}`, {
        method: "GET",
        headers: {
          'Authorization': Auth()
        }
      });
      let data = await response.json();
      console.log(data, 'helloo')
      setBodyData(data.emailBody)
      setSubjectData(data.subject)
      setStatusToggle(data.status)
      }catch(err) {
        console.log(err)
      }
    }
    fetchData()
    // Fetch Variable
    const fetchVariable = async () => {
      try {
        let response = await fetch(`${process.env.REACT_APP_NOTIFICATION_BASE_URL}/variables`, {
          method: "GET",
          headers: {
            'Authorization': Auth()
          }
        })
        let data = await response.json()
        setVariables(data)
      }catch(err) {
        console.log(err)
      }
    }
    fetchVariable()
},[id,undoCounter])

const updateHandler = () => {
  setLoadingToggle(true)
  let data = JSON.stringify({
    "status": statusToggle,
    "subject": `${subjectData}`,
    "emailBody": `${bodyData}`
  });
  
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_NOTIFICATION_BASE_URL}/update-notification/${id}`,
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': Auth()
    },
    data : data
  };
  
  axios.request(config)
  .then((response) => {
    setLoadingToggle(false)
    console.log(JSON.stringify(response.data));
    toast({
      title: `Notitfication upadated successfully`,
      position: 'top',
      status: 'success',
      isClosable: true,
      duration: 4000
    })
  })
  .catch((error) => {
    setLoadingToggle(false)
    console.log(error);
    toast({
      title: `Something went wrong`,
      position: 'top',
      status: 'error',
      duration: 4000,
      isClosable: true,
    })
  });
}

const statusHandler = (e) => {
  e.target.checked === false ? setStatusToggle(false) : setStatusToggle(true)
}

  return (
    <Fragment>
        <Flex p={5} bgColor='#F5F5F5' justifyContent={'space-around'} width={'80%'} >
          <Flex flexBasis={'67%'} flexDirection={'column'}>
            <Flex justifyContent={'space-between'} alignItems={'center'} w={'full'}>
               <BiArrowBack fontSize={'31px'} style={{cursor: "pointer"}}  onClick={() => navigate("/notifications/all")}/>
              <Text ml={4} fontSize={'24px'} fontWeight={'semibold'} flexBasis={'80%'}>Notification Triggers</Text>
              <Flex alignItems={'center'}  justifyContent={'flex-end'} flexBasis={'20%'}>
                <Switch isChecked={statusToggle} onChange={(e) => statusHandler(e)}/>
              </Flex>
            </Flex>
            {/* Subject */}
            <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} p={4} my={6} mb={3} bgColor={'rgba(255, 255, 255, 1)'}>
              <Heading size={'md'}>Subject</Heading>
              <Divider size={1} my={2} borderBottomColor={'black'} />
              <Input border={'unset'} py={2} px={1} value={subjectData} onChange={(e) => setSubjectData(e.target.value)} placeholder='Add subject' />
            </Box>
            {/* body */}
            <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} p={4} my={1} bgColor={'rgba(255, 255, 255, 1)'}>
              <Flex justifyContent={'space-between'}>
              <Heading size={'md'}>Body</Heading>
              
              </Flex>
              <Divider size={1} my={2} borderBottomColor={'black'} />
              <ReactQuill theme="snow"  value={bodyData} onChange={setBodyData} />
            </Box>
            {/* buttons */}
            <Flex w={'full'} justifyContent={'flex-end'} my={3}>
              <Box>
                <Button colorScheme='facebook' mr={4} size={'sm'} onClick={() => setUndoCounter((prev) => undoCounter + 1)} px={6}>Undo Changes</Button>
                <Button isLoading={loadingToggle} colorScheme='twitter' size={'sm'} px={6} onClick={updateHandler}>Update</Button>
              </Box>
            </Flex>
          </Flex>
        <Flex flexBasis={'31%'} >
            <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} p={4}  bgColor={'rgba(255, 255, 255, 1)'} w={'full'} h={'125px'} marginTop={'60px'}>
              <Heading size={'md'}>Variables</Heading>
              <Divider size={1} my={2} borderBottomColor={'black'} />
              <Select placeholder='Select Variables' onChange={(e) => variableHandler(e)}>
                {variables.map((d,i) =>  {
                  return (
                  <option key={i} value={d.varible}>{d.variable}</option>
                )})}
              </Select>
            </Box>
        </Flex>
        </Flex>
    </Fragment>
  )
}

export default NotificationDetails